// extracted by mini-css-extract-plugin
export default {"pagination":"userstaple_pagination__K3phS","usersTaple":"userstaple_usersTaple__zPrXo","markRow":"userstaple_markRow__nPVJg"};